import { render, staticRenderFns } from "./ed-layout-basic.vue?vue&type=template&id=42afbadc&scoped=true&"
import script from "./ed-layout-basic.ts?vue&type=script&lang=ts&"
export * from "./ed-layout-basic.ts?vue&type=script&lang=ts&"
import style0 from "./ed-layout-basic.scss?vue&type=style&index=0&id=42afbadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afbadc",
  null
  
)

export default component.exports